import { render, staticRenderFns } from "./AdminMain.vue?vue&type=template&id=45db121e&scoped=true"
import script from "./AdminMain.vue?vue&type=script&lang=ts"
export * from "./AdminMain.vue?vue&type=script&lang=ts"
import style0 from "./AdminMain.vue?vue&type=style&index=0&id=45db121e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db121e",
  null
  
)

export default component.exports